import { render, staticRenderFns } from "./chrome.vue?vue&type=template&id=2616db86&lang=html&"
import script from "./chrome.vue?vue&type=script&lang=js&"
export * from "./chrome.vue?vue&type=script&lang=js&"
import style0 from "./chrome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "chrome.vue"
export default component.exports